import { Datagrid, ReferenceManyField, ShowButton, TextField, useRecordContext } from "react-admin";
import Typography from "@mui/material/Typography";
import type { RaRecord } from "react-admin";

function familyMembersSource(record: RaRecord | undefined): string | null {
  if (!record) return null;
  if (record.HOF_FM_TYPE === "HOF") return "ITS_ID";
  if (record.HOF_ID) return "HOF_ID";
  return null;
}

export default function FamilyMembers() {
  const record = useRecordContext();
  const source = familyMembersSource(record);

  if (!source) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ px: 2, py: 1 }}>
        No household HOF linked.
      </Typography>
    );
  }

  return (
    <ReferenceManyField reference="itsdata" target="HOF_ID" source={source} label={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="ITS_ID" label="ITS No." />
        <TextField source="HOF_FM_TYPE" label="Type" />
        <TextField source="HOF_ID" label="HOF" />
        <TextField source="Full_Name" label="Name" />
        <TextField source="Age" label="Age" />
        <TextField source="Gender" label="Gender" />
        <TextField source="Mobile" />
        <ShowButton />
      </Datagrid>
    </ReferenceManyField>
  );
}
